export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14322.b7362a52.jpg";